import { Container, ContainerMain } from "./styles";
import { useCallback, useEffect } from "react";

import AppBar from "./appbar";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import SideBar from "./sidebar";
import { Typography } from "@mui/material";
import { useAuth } from "../../context/global";
import { useState } from "react";

const drawerwidth = 240;

function Layout({ children }: { children: any }) {
    const { sidebarOpen, setSidebarOpen, handleGetDataUser, user } = useAuth();
    const [base, setBase] = useState<any>();

    useEffect(() => {
        const a = handleGetDataUser();
        if (a) {
            setBase(a);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user]);

    const handleToggleSidebar = useCallback(() => {
        setSidebarOpen(!sidebarOpen);
    }, [sidebarOpen, setSidebarOpen]);

    return (
        <Container>
            {base ? (
                <>
                    <AppBar width={drawerwidth} expanded={sidebarOpen} />
                    <SideBar width={drawerwidth} expanded={sidebarOpen} onToggle={handleToggleSidebar} />
                    <ContainerMain width={drawerwidth} expanded={sidebarOpen ? 0 : 1}>
                        {children}
                    </ContainerMain>
                </>
            ) : (
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        flexDirection: "column",
                        alignItems: "center",
                        width: "100%",
                    }}
                >
                    <Typography variant="h6" sx={{ mb: 2 }}>
                        Carregando...
                    </Typography>
                    <CircularProgress />
                </Box>
            )}
        </Container>
    );
}

export default Layout;
